import React from 'react';
import {CommunicatorState} from "../state/ui/CommunicatorState";

export const SetCommunicatorStateContext = React.createContext((communicatorState: CommunicatorState) => {});